import React, { useEffect, useRef, useState } from "react";

export default function Gallery() {
  const [isVisible, setIsVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        },
        { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const galleryItems = [
    { type: "image", src: "assets/images/1.jpg", title: "Tampak Depan 1" },
    { type: "image", src: "assets/images/2.jpg", title: "Tampak Depan dan Samping" },
    { type: "image", src: "assets/images/3.jpg", title: "Tampak Samping 1" },
    { type: "image", src: "assets/images/4.jpg", title: "Tampak Depan 2" },
    { type: "image", src: "assets/images/5.jpg", title: "Tampak Samping 2" },
    { type: "image", src: "assets/images/6.jpg", title: "Tampak Samping 3" },
    { type: "image", src: "assets/images/7.jpg", title: "Tampak Belakang" },
    { type: "image", src: "assets/images/8.jpg", title: "Tampak Samping 4" },
    { type: "image", src: "assets/images/9.jpg", title: "Tampak Depan 3" },
    { type: "image", src: "assets/images/t1.jpg", title: "Tampak Samping Mobil Terbuka" },
    { type: "image", src: "assets/images/t2.jpg", title: "Tampak Depan 3 Mobil" },
    { type: "video", src: "assets/images/vid1.mp4", title: "Video Tampak Depan" }
  ];

  return (
      <section
          id="gallery"
          ref={sectionRef}
          className="py-32 bg-white relative overflow-hidden"
      >
        <div className="container mx-auto px-6 lg:px-12">
          <div className="text-center mb-20">
            <h2
                className={`text-5xl lg:text-6xl font-bold text-gradient mb-6 transition-all duration-1000 ${
                    isVisible
                        ? "opacity-100 translate-y-0"
                        : "opacity-0 translate-y-20"
                }`}
            >
              Galeri Kami
            </h2>
            <p
                className={`text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed transition-all duration-1000 ${
                    isVisible
                        ? "opacity-100 translate-y-0"
                        : "opacity-0 translate-y-20"
                }`}
                style={{ transitionDelay: "0.1s" }}
            >
              Dokumentasi layanan dan armada pengiriman kami
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {galleryItems.map((item, index) => (
                <div
                    key={index}
                    onClick={() => setSelectedImage(item)}
                    className={`group relative h-72 rounded-3xl overflow-hidden shadow-xl cursor-pointer card-premium transition-all duration-1000 ${
                        isVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"
                    }`}
                    style={{ transitionDelay: `${0.2 + index * 0.05}s` }}
                >
                  {item.type === "image" ? (
                      <img
                          src={item.src}
                          alt={item.title}
                          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                      />
                  ) : (
                      <video
                          src={item.src}
                          className="w-full h-full object-cover"
                          muted
                          loop
                          playsInline
                      />
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center">
                    <div className="text-center text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500 px-4">
                      {item.type === "video" ? (
                          <svg
                              className="w-12 h-12 mx-auto mb-2"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              viewBox="0 0 24 24"
                          >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                            />
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                      ) : (
                          <svg
                              className="w-12 h-12 mx-auto mb-2"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              viewBox="0 0 24 24"
                          >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                            />
                          </svg>
                      )}
                      <p className="font-semibold text-lg">{item.title}</p>
                    </div>
                  </div>
                </div>
            ))}
          </div>

          {/* Lightbox */}
          {selectedImage && (
              <div
                  className="fixed inset-0 bg-black/95 backdrop-blur-xl z-50 flex items-center justify-center p-6 animate-fadeIn"
                  onClick={() => setSelectedImage(null)}
              >
                <div className="relative max-w-6xl w-full h-[85vh]">
                  {selectedImage.type === "image" ? (
                      <img
                          src={selectedImage.src}
                          alt={selectedImage.title}
                          className="w-full h-full object-contain"
                      />
                  ) : (
                      <video
                          src={selectedImage.src}
                          className="w-full h-full object-contain"
                          controls
                          autoPlay
                          loop
                      />
                  )}
                  <div className="absolute bottom-6 left-6 right-6 text-center">
                    <p className="text-white text-xl font-semibold bg-black/50 backdrop-blur-md py-3 px-6 rounded-full inline-block">
                      {selectedImage.title}
                    </p>
                  </div>
                  <button
                      onClick={() => setSelectedImage(null)}
                      className="absolute top-6 right-6 w-14 h-14 glass rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300 glow"
                  >
                    <svg
                        className="w-7 h-7"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        viewBox="0 0 24 24"
                    >
                      <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>
          )}
        </div>
      </section>
  );
}